import { ActivatedRoute, Params, Router, RouterEvent } from '@angular/router';
import { LinkService } from 'src/app/services/general/link.service';
import { AppService } from 'src/app/services/general/app.service';
import { Platform } from '@ionic/angular';
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';

@Component({
  selector: 'app-app-download',
  templateUrl: './app-download.page.html',
  styleUrls: ['./app-download.page.scss'],
})
export class AppDownloadPage implements OnInit, OnDestroy {

  showPage: boolean;

  iosApp: boolean;

  private ready: boolean;

  private backHelpPage: boolean;

  constructor(
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private router: Router,
    private platform: Platform,
    private appService: AppService,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {

  }

  ionViewWillEnter() {
    if (this.platform.is('hybrid') && this.platform.is('ios')) {
      this.iosApp = true;
    }
  }

  async ionViewDidEnter() {
    await this.platform.ready();
    this.ready = true;
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (state?.showPage === 'true' || state?.showPage === true) {
        this.showPage = true;
      } else if (param?.showPage === 'true' || param?.showPage === true) {
        this.showPage = true;
      } else {
        this.showPage = false;
      }

      if (param.backHelpPage) {
        this.backHelpPage = true;
      } else if (state?.backHelpPage) {
        this.backHelpPage = true;
      } else {
        this.backHelpPage = false;
      }
      if (!this.showPage) {
        this.checkGoStore();
      }
    });
  }

  goBack() {
    if (this.backHelpPage) {
      this.goHelpPage();
    } else {
      this.goMainPage();
    }
  }

  goHelpPage() {
    this.router.navigate(['/about/help']);
  }

  /**
   * Go main page
   */
  goMainPage() {
    this.linkService.goMainPage();
  }

  goWebsite() {
    this.linkService.goWebsite();
  }

  checkGoStore() {
    if (this.ready) {
      this.goStore();
    } else {
      setTimeout(() => {
        this.checkGoStore();
      }, 200);
    }
  }

  async goStore() {
    await this.platform.ready();
    this.ngZone.run(async () => {
      await this.appService.goStore();
      this.showPage = true;
    });
  }

  openAppStore() {
    this.appService.openAppStore();
  }

  openPlayStore() {
    this.appService.openPlayStore();
  }

  openAppGallery() {
    this.appService.openAppGallery();
  }

  openWebVersion() {
    if (this.iosApp) {

    } else {
      this.appService.openWebVersion();
    }
  }
}
